import { ProductImageMapLine } from 'Components/lines/product-image-map-line/ProductImageMapLine';
export default ProductImageMapLine;
